import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from 'react-router-dom';
import moment from "moment";

import Lottie from "lottie-react";
import HighFive from "../animations/high-five.json";

import CircularProgressBar from "../../../common/CircularProgressBar";
import { delay } from "../../../utils";
import { GetAllWorkOutHistoriesWithArchived, } from "../../../redux/v2/user/actions";
import OneToTenOptions from "../../getting-started/components/OneToTenOptions";
import CustomButton from "../../../common/CustomButton";
import toast from "react-hot-toast";

import { SubmitPostWorkoutRating } from "../../../redux/v2/workout/actions"

function PostWorkoutMessage(props) {
    const navigate = useNavigate()

    const [rate, setRate] = useState(null);
    const [feedback, setFeedback] = useState("");
    const [status, setStatus] = useState("pre-sub");
    const [flip, setFlip] = useState(true);

    const [flipVis, setFlipVis] = useState({
        h4: false,
        sForm: false,
        h42: false,
        ta: false,
        btn: false,
    });

    useEffect(() => {

    }, []);

    useEffect(() => {
        if (flip) {

            delay(() => {
                setFlipVis((fv) => {
                    return {
                        ...fv,
                        h4: true
                    }
                });
            }, 400)
            delay(() => {
                setFlipVis((fv) => {
                    return {
                        ...fv,
                        sForm: true
                    }
                });
            }, 800)
            delay(() => {
                setFlipVis((fv) => {
                    return {
                        ...fv,
                        h42: true
                    }
                });
            }, 1200)
            delay(() => {
                setFlipVis((fv) => {
                    return {
                        ...fv,
                        ta: true
                    }
                });
            }, 1600)
            delay(() => {
                setFlipVis((fv) => {
                    return {
                        ...fv,
                        btn: true
                    }
                });
            }, 2000)

        }

    }, [flip])

    return (
        <div id="post-workout-message">
            <div id="post-workout-message-wrapper">
                <div id="high-five-animation-container">
                    <Lottie className="high-five-animation" animationData={HighFive} loop={false} />
                    <h3>Way to go!</h3>
                </div>

                {flip && <div id="pwm-survey-form" className='at-v2 stats'>
                    <h4 className={`flip ${flipVis.h4 ? "fshow" : ""}`}>Rate Your Workout</h4>

                    <div className={`survey-options flip ${flipVis.sForm ? "fshow" : ""}`} >
                        <p style={{ alignSelf: "start" }}>Least Difficult</p>
                        <OneToTenOptions value={rate} onChange={(val) => {
                            setRate(val);
                        }} />
                        <p style={{ alignSelf: "end" }}>Most Difficult</p>
                    </div>

                    <h4 className={`flip ${flipVis.h42 ? "fshow" : ""}`}>Tell Us How It Went!</h4>

                    <textarea className={`form-control flip ${flipVis.ta ? "fshow" : ""}`} placeholder="Type here..."
                        onChange={(e) => {
                            setFeedback(e.target.value)
                        }}
                    />

                    <CustomButton disabled={!rate} className={`flip ${flipVis.btn ? "fshow" : ""}`}
                        onClick={async () => {
                            if (status == "pre-sub") {
                                setStatus("submitting");
                                const toastId = toast.loading("Submitting...");
                                const res = await props.SubmitPostWorkoutRating(rate, feedback, props.workout.id);
                                if (res) {
                                    toast.success('Rate Submitted!', {
                                        id: toastId,
                                    });

                                    delay(() => {
                                        navigate("/home")
                                    }, 1000)
                                } else {
                                    toast.error("Failed to Submit Rating.", {
                                        id: toastId,
                                    });

                                    setStatus("pre-sub");
                                }
                            }
                        }}
                    >Submit</CustomButton>
                </div>}
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    GetAllWorkOutHistoriesWithArchived,
    SubmitPostWorkoutRating,
})(PostWorkoutMessage);